import { Container, Row, Col } from "react-bootstrap"
import "../scss/reward.scss"


const Reward = (props) => {
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    return (
        <div className="reward-page">
            <Container>
                {Object.values(props.table).map((val, key) => (
                    <div className="reward-category" key={key}>
                        <div className="title-reward">{val[0].emulationCategory.group_name}</div>
                        <div className="list-reward">   
                            <Row>
                                {val.map((v, k) =>(
                                    <Col xs={12} md={6} key={k}>
                                        <div className="item-reward">
                                            <div className="title-detail">
                                                {v.rule_name}
                                                <div className="count"><span>{v.countTaget}</span>/{v.max_used < 100 ? v.max_used: 'Tất cả' } KTV</div>
                                            </div>
                                            <div className="content-reward">
                                                <div className="progress-striped">
                                                    <div className="progress-bar" style={{width: v.percent+'%', maxWidth: "100%"}}>
                                                        <div className="current-process"><div className="icon"></div></div>
                                                    </div>       
                                                    <div className="end-process"><div className="icon"></div></div>                
                                                </div>
                                                <div className="text-process">
                                                    {v.value == 0 ?
                                                        <span style={{fontSize: '12px'}}>Chưa đủ điều kiện nhận thưởng</span>
                                                    :
                                                        <span style={{fontSize: '13px'}}>Giải thưởng: <span style={{color: 'red'}}>{v.value > 100 ? convertCurrency(Number(v.value)) : v.value + '%'}</span></span>
                                                    }
                                                </div>
                                                <div className="text-process">
                                                    <div className="buy">Đạt: <span>{v.target_action < 1000 ? v.count_services : convertCurrency(v.total_paid) }</span></div>
                                                    <div className="total">Tổng số: <span>{v.target_action > 1000 ? convertCurrency(v.target_action) : v.target_action }</span></div>
                                                </div>
                                                <div className="text-success">
                                                    {v.rank > 0 ? "Chúc mừng bạn đã hoàn thành thi đua với thứ hạng: " + String(v.rank).padStart(2, '0')  : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                ))}
            </Container>
        </div>
    )
}
export default Reward